import { useMemo } from 'react';

import { oneTimeMessagesDismissedState } from '@trello/business-logic-react/member';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useSharedState } from '@trello/shared-state';

import {
  PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE,
  PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED,
} from './InboxNotifications.constants';

export const useUnreadInboxNotifications = () => {
  const [{ oneTimeMessagesDismissed }] = useSharedState(
    oneTimeMessagesDismissedState,
  );
  const { value: isGhostAddToInboxEnabled } = useFeatureGate(
    'ghost_add_to_inbox_gate',
  );

  return useMemo(() => {
    if (!isGhostAddToInboxEnabled) {
      return null;
    }

    const cardIds = oneTimeMessagesDismissed
      .filter((message) =>
        message.startsWith(`${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE}:`),
      )
      .map((message) =>
        message.replace(`${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE}:`, ''),
      );
    if (cardIds.length === 0) {
      return null;
    }

    const dismissedCardIds = new Set(
      oneTimeMessagesDismissed
        .filter((message) =>
          message.startsWith(
            `${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED}:`,
          ),
        )
        .map((message) =>
          message.replace(
            `${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED}:`,
            '',
          ),
        ),
    );

    // Check if there're planner card that don't have a corresponding dismissed message
    const unreadCardNotifications = cardIds.filter(
      (cardId) => !dismissedCardIds.has(cardId),
    );

    return new Set(unreadCardNotifications);
  }, [oneTimeMessagesDismissed, isGhostAddToInboxEnabled]);
};
